import { $, $$, offset } from '../helper/utils';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

let hrefs = document.querySelectorAll('a[href^="#"]');

for (let i = 0; i < hrefs.length; i++) {
  let elm = hrefs[i];

  elm.addEventListener('click', function (e) {

    let targetElm = document.querySelector(this.getAttribute('href')).closest('.container-sector');

    if (targetElm.offsetTop != null) {
      e.preventDefault();
      let top = offset(targetElm).top;
      // console.log(top);
      // const start = this.getBoundingClientRect();
      // const factor = Math.round(Math.abs(top / start.height));
      gsap.to(window,{
        // duration: 2 / 100 * top / 20,
        // duration: 0.15 + (0.025 * factor),
        duration: 1,
        ease: "power2.in",
        scrollTo: top,
        // onComplete: updateDocument,
        onCompleteParams: [top]
      });
    }
  });
}

// // keep scrollbar position in sync
// const updateDocument = (offset) => {
//   console.log(offset);
// }
